import type { ReactNode } from 'react';
import Navbar from '../navbar/Navbar';

const ROOT_CLASS = 'flex flex-1 w-full';
const MAIN_CLASS = 'relative flex-1 pb-[170px] px-9 pt-10';

const SIDEBAR = (
    <aside className="min-w-64 flex-none" aria-label="Menu principal">
        <Navbar />
    </aside>
);

type PageLayoutProps = Readonly<{
    children: ReactNode;
}>;

export function PageLayout({ children }: PageLayoutProps) {
    return (
        <div className={ROOT_CLASS}>
            {SIDEBAR}
            <main className={MAIN_CLASS}>{children}</main>
        </div>
    );
}
